import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const createPackageSameCode = createAction(ACTION.CREATE_PACKAGE_SAME_CODE.REQUEST, data => data);
export const clearState = createAction(ACTION.CLEAR_STATE);
